interface ILoaderProps {
  className?: string;
  colorClassName?: string;
  customClass?: boolean;
}

export function Loader({
  className = "",
  customClass = false,
  colorClassName = "text-purple-700",
}: ILoaderProps) {
  return (
    <>
      {customClass ? (
        <div className={className}>
          <span
            className={`loading loading-spinner w-[3rem] ${colorClassName}`}
          />
        </div>
      ) : (
        <div
          className={`${
            className || ""
          }  w-full h-full flex items-center justify-center`}
        >
          <span
            className={`loading loading-spinner w-[3rem] ${colorClassName}`}
          />
        </div>
      )}
    </>
  );
}
